import PropTypes from 'prop-types'
import React from 'react'

import FormSection from '../../shared/components/FormSection'
import AttributedListInput from '../../shared/components/AttributedListInput'
// import TextArea from '../../shared/components/TextArea'

const EquipmentFormSection = ({
  equipments = [],
  qs = [],
  show,
  validationObj,
  onChange,
  readOnly,
  fieldSpecs
}) => {

  return (
    <FormSection
      title="4. Ausstattung und Maßnahmen zur Qualitätssicherung"
      show={show}
    >
      <AttributedListInput
        name="equipments"
        placeholder="Anzahl"
        info="(und Anzahl)"
        list={window.APP_CONFIG.list_equipment}
        value={equipments.toJS ? equipments.toJS() : equipments}
        onChange={onChange}
        isValid={validationObj.equipments}
        disabled={readOnly}
        {...fieldSpecs.equipments}
      />

      <AttributedListInput
        name="qs"
        list={window.APP_CONFIG.list_qs}
        value={qs.toJS ? qs.toJS() : qs}
        onChange={onChange}
        isValid={validationObj.qs}
        hideAttribute
        disabled={readOnly}
        {...fieldSpecs.qs}
      />

    </FormSection>
  )
}

EquipmentFormSection.propTypes = {
  show: PropTypes.bool
}

export { EquipmentFormSection as default }



// WEBPACK FOOTER //
// ./src/museum/components/04-EquipmentFormSection.js